import { WalletType } from "../shared";

export type PortfolioToken = {
  token: string;
  balancesByAccount: PortfolioTokenByAccount[];
} & TokenBalance;

export type PortfolioTokenByAccount = {
  accountId: string;
  accountName: string;
  exchangeId: string;
  walletTypes: {
    [walletType in WalletType]?: TokenBalance;
  };
} & TokenBalance;

export type TokenBalance = {
  tokenName?: string;
  totalBalance: number;
  refTotalBalance: number;
  freeBalance: number;
  refFreeBalance: number;
};

export type TokenBalanceV2 = {
  tokenName?: string;
  totalBalance: string;
  refTotalBalance: string;
  freeBalance: string;
  refFreeBalance: string;
};

export type Token = {
  exchangeId: string;
  accountName: string;
  token: string;
  totalBalance: number;
  freeBalance: number;
  refTotalBalance?: number;
  refFreeBalance?: number;
};

export type GroupedBalances = {
  [tokenSymbol: string]: TokenBalance;
};

export type TotalBalancesByAccountId = {
  [accountId: string]: {
    total: number;
    isLoading: boolean;
    isError: boolean;
  };
};
